export default function EmptyState({ title, message, action }) {
  return (
    <div className="state-block state-block--empty">
      <div className="state-block__icon" aria-hidden="true">
        <svg viewBox="0 0 48 48" width="40" height="40" fill="none">
          <rect x="8" y="14" width="32" height="24" rx="3" stroke="currentColor" strokeWidth="2" />
          <path d="M8 22h32" stroke="currentColor" strokeWidth="2" />
          <circle cx="16" cy="10" r="3" stroke="currentColor" strokeWidth="2" />
          <circle cx="24" cy="10" r="3" stroke="currentColor" strokeWidth="2" />
        </svg>
      </div>
      <div className="state-block__title">{title}</div>
      {message && <div className="state-block__text">{message}</div>}
      {action && <div className="state-block__action">{action}</div>}
    </div>
  );
}
